import {secondsToTimeDuration} from 'webapp-lib/utils';

import i18n from '_/i18n';

export const toLocalizedDuration = (durationInSeconds: number): string =>
  i18n.t('common:temporal.durationInHours', {
    duration: secondsToTimeDuration(durationInSeconds),
  });

export const getLocalizedDurationUnit = (): string =>
  i18n.t('common:abbreviations.hour');

export const formattedHoursWithUnit = (durationInHours: number): string =>
  i18n.t('common:temporal.durationInHours', {
    duration: durationInHours.toFixed(2),
  });
